import {SlideBase} from './SlideBase';
import {SlideProps} from './tipos';
import {APP_RECURSOS, MIDIA} from './dados';
import {Midia} from '../midia';

export function SlideApp({vertical}: SlideProps) {
	return (
		<SlideBase vertical={vertical}>
			<div className="slide-app">
				<div className="slide-app-mockup">
					<Midia src={`${MIDIA}/app_mockup.png`} alt="Aplicativo Netcomet"/>
				</div>
				<div className="slide-app-texto">
					<span className="slide-sobretitulo">Aplicativo Netcomet</span>
					<h1>Seus boletos<br/>no seu bolso</h1>
					<ul className="slide-app-recursos">
						{APP_RECURSOS.map(r => (
							<li key={r.titulo}>
								<span className="material-icons" aria-hidden="true">{r.icone}</span>
								<div><strong>{r.titulo}</strong><span>{r.texto}</span></div>
							</li>
						))}
					</ul>
					<div className="slide-app-lojas">
						<Midia src={`${MIDIA}/appstore.png`} alt="Disponível na App Store"/>
						<Midia src={`${MIDIA}/googleplay.webp`} alt="Disponível no Google Play"/>
					</div>
				</div>
			</div>
		</SlideBase>
	);
}
